import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import {
  Tooltip,
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  DialogContent
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import { RouteComponentProps } from 'react-router';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable, {
  SelectableRows,
  MUIDataTableMeta,
  MUIDataTableColumnOptions
} from 'mui-datatables';
import { MUITranslations } from '../../../helpers/MUITableTranslations';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import { ReferentialCode } from '../../../helpers/Constants';
import Referentials from '../../../helpers/Referentials.json';
import { IReferential } from '../../../interfaces/IReferential';
import moment from 'moment';
import { IReferentialService } from '../../../services/Interfaces/IReferentialService';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { MaintenanceWorkflow } from '../../../interfaces/Organization';
import { IOrganizationService } from '../../../services/Interfaces/IOrganizationService';
import NumberFormat from 'react-number-format';

interface IConfigurableWorkflowComponentState {
  newMaintenanceWorkflow: MaintenanceWorkflow;
  maintenanceWorkflows: MaintenanceWorkflow[];
  isLoading: boolean;
  isDialogOpen: boolean;
  newMaintenanceWorkflowId: number | null;
  countryList: IReferential[];
  partnerClientList: IReferential[];
  workflowTypeList: IReferential[];
}
type IConfigurableWorkflowComponentProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string; workflowId: string }>;
class ConfigurableWorkflowComponent extends React.PureComponent<
  IConfigurableWorkflowComponentProps,
  IConfigurableWorkflowComponentState
> {
  private translatorService!: ITranslatorService;
  private organizationService!: IOrganizationService;
  private appReferentialService!: IReferentialService;
  static contextType = ApplicationContext;
  private newMaintenanceWorkflow = {
    id: 0,
    countryId: 0,
    country: null
  } as MaintenanceWorkflow;

  state = {
    isLoading: false,
    isDialogOpen: false,
    newMaintenanceWorkflow: this.newMaintenanceWorkflow,
    maintenanceWorkflows: [],
    newMaintenanceWorkflowId: null,
    countryList: [] as IReferential[],
    partnerClientList: [] as IReferential[],
    workflowTypeList: [] as IReferential[]
  } as IConfigurableWorkflowComponentState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadMaintenanceWorkflows();
      }
    );
  }

  loadMaintenanceWorkflows = async () => {
    const countryRef = Referentials.referential.find(
      (item) => item.code === ReferentialCode.Country
    );
    const partnerClientRef = Referentials.referential.find(
      (item) => item.code === ReferentialCode.PartnerClient
    );
    const workflowTypeRef = Referentials.referential.find(
      (item) => item.code === ReferentialCode.WorkflowType
    );
    const [maintenanceWorkflows, countryList, partnerClientList, workflowTypeList] =
      await Promise.all([
        this.organizationService.GetUserMaintenanceWorkflows(),
        this.appReferentialService.Get(countryRef!.baseUrl),
        this.appReferentialService.Get(partnerClientRef!.baseUrl),
        this.appReferentialService.Get(workflowTypeRef!.baseUrl)
      ]);

    this.setState({
      maintenanceWorkflows: maintenanceWorkflows,
      isLoading: false,
      newMaintenanceWorkflow: { ...this.newMaintenanceWorkflow },
      countryList: countryList,
      partnerClientList: partnerClientList,
      workflowTypeList: workflowTypeList
    });
  };

  private handleCountryChange = (newValue: IReferential | null) => {
    this.setState({
      newMaintenanceWorkflow: {
        ...this.state.newMaintenanceWorkflow,
        country: newValue,
        countryId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  private handlePartnerClientChange = (newValue: IReferential | null) => {
    this.setState({
      newMaintenanceWorkflow: {
        ...this.state.newMaintenanceWorkflow,
        partnerClient: newValue,
        partnerClientId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  private handleWorkflowTypeChange = (newValue: IReferential | null) => {
    this.setState({
      newMaintenanceWorkflow: {
        ...this.state.newMaintenanceWorkflow,
        workflowType: newValue,
        workflowTypeId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  private handleWorkflowIdChange = (value: string) => {
    this.setState({
      newMaintenanceWorkflow: {
        ...this.state.newMaintenanceWorkflow,
        workflowId: parseInt(value)
      }
    });
  };

  public saveMaintenanceWorkflow = async () => {
    if (this.state.newMaintenanceWorkflowId === null) {
      if (
        this.state.maintenanceWorkflows.findIndex(
          (item) =>
            item.countryId === this.state.newMaintenanceWorkflow.countryId &&
            item.partnerClientId === this.state.newMaintenanceWorkflow.partnerClientId &&
            item.workflowTypeId === this.state.newMaintenanceWorkflow.workflowTypeId
        ) !== -1
      ) {
        this.props.enqueueSnackbar(
          this.translatorService.Tranlate(
            'MAINTENANCE_WORKFLOW_ALREADY_EXIST',
            'Exista deja un flux de mentenanta pentru aceasta combinatie de tara, client partener si tip workflow!'
          ),
          { variant: 'error' }
        );
        return;
      }
      try {
        await this.organizationService.AddMaintenanceWorkflow(this.state.newMaintenanceWorkflow);
        await this.loadMaintenanceWorkflows();
        this.closeDialog();
        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    } else {
      try {
        await this.organizationService.UpdateMaintenanceWorkflow(this.state.newMaintenanceWorkflow);
        await this.loadMaintenanceWorkflows();
        this.closeDialog();
        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };

  NumberFormatCustom = (props: any) => {
    const { inputRef, onChange, ...other } = props;
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values: any) => {
          onChange({
            target: {
              value: values.value
            },
            currentTarget: {
              value: values.value
            }
          });
        }}
        allowNegative={false}
        thousandSeparator={false}
        decimalScale={2}
      />
    );
  };

  public renderAddForm() {
    return (
      <ValidatorForm onSubmit={this.saveMaintenanceWorkflow} instantValidate={true}>
        <Box mb={2}>
          <Autocomplete
            id="country"
            fullWidth
            options={this.state.countryList}
            value={this.state.newMaintenanceWorkflow.country || ''}
            onChange={(e: any, newValue: IReferential | null) => this.handleCountryChange(newValue)}
            getOptionLabel={(option: IReferential) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="country"
                value={this.state.newMaintenanceWorkflow.country || ''}
                label={this.translatorService.Tranlate('EDIT_ORGANIZATION_COUNTRY_LABEL', 'Tara')}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
                ]}
              />
            )}
          />
        </Box>
        <Box mb={2}>
          <Autocomplete
            id="partnerClient"
            fullWidth
            options={this.state.partnerClientList}
            value={this.state.newMaintenanceWorkflow.partnerClient || ''}
            onChange={(e: any, newValue: IReferential | null) =>
              this.handlePartnerClientChange(newValue)
            }
            getOptionLabel={(option: IReferential) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="partnerClient"
                value={this.state.newMaintenanceWorkflow.partnerClient || ''}
                label={this.translatorService.Tranlate(
                  'EDIT_ORGANIZATION_PARTNER_CLIENT_LABEL',
                  'Client Partener'
                )}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
                ]}
              />
            )}
          />
        </Box>
        <Box mb={2}>
          <Autocomplete
            id="workflowType"
            fullWidth
            options={this.state.workflowTypeList}
            value={this.state.newMaintenanceWorkflow.workflowType || ''}
            onChange={(e: any, newValue: IReferential | null) =>
              this.handleWorkflowTypeChange(newValue)
            }
            getOptionLabel={(option: IReferential) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="workflowType"
                value={this.state.newMaintenanceWorkflow.workflowType || ''}
                label={this.translatorService.Tranlate(
                  'EDIT_ORGANIZATION_WORKFLOW_TYPE_LABEL',
                  'Tip Workflow'
                )}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
                ]}
              />
            )}
          />
        </Box>
        <Box mb={2}>
          <TextValidator
            fullWidth
            name="workflowId"
            id="workflowId"
            value={this.state.newMaintenanceWorkflow.workflowId || ''}
            onChange={(e: any) => this.handleWorkflowIdChange(e.target.value)}
            label={this.translatorService.Tranlate(
              'MAINTENANCE_WORKFLOW_WORKFLOW_ID_LABEL',
              'Workflow Id'
            )}
            validators={['required']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
            ]}
          />
        </Box>

        <div className="text-right">
          <Button className="m-2" variant="outlined" color="default" onClick={this.closeDialog}>
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_CANCEL_BTN', 'Anuleaza')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
          </Button>
        </div>
      </ValidatorForm>
    );
  }

  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: { display: 'excluded', filter: false } as MUIDataTableColumnOptions
      },
      {
        name: 'country',
        label: this.translatorService.Tranlate('ORGANIZATIONS_COUNTRY_HEADER', 'Tara'),
        options: {
          sort: true,
          customSort: (a: IReferential, b: IReferential) => {
            debugger;
            return a.name!.localeCompare(b.name!);
          },
          customBodyRender: (value: IReferential) => {
            return value ? value.displayName : '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'partnerClient',
        label: this.translatorService.Tranlate(
          'ORGANIZATIONS_CLIENT_PARTNER_HEADER',
          'Client Partener'
        ),
        options: {
          sort: true,
          customSort: (a: IReferential, b: IReferential) => {
            debugger;
            return a.name!.localeCompare(b.name!);
          },
          customBodyRender: (value: IReferential) => {
            return value ? value.displayName : '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'workflowType',
        label: this.translatorService.Tranlate(
          'ORGANIZATIONS_WORKFLOW_TYPE_HEADER',
          'Tip Workflow'
        ),
        options: {
          sort: true,
          customSort: (a: IReferential, b: IReferential) => {
            debugger;
            return a.name!.localeCompare(b.name!);
          },
          customBodyRender: (value: IReferential) => {
            return value ? value.displayName : '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'workflowId',
        label: this.translatorService.Tranlate(
          'MAINTENANCE_WORKFLOW_WORKFLOW_ID_LABEL',
          'Workflow Id'
        )
      },
      {
        name: 'dateModification',
        label: this.translatorService.Tranlate('USERS_DATE_MODIFICATION_HEADER', 'Data Modificare'),
        options: {
          filter: false,
          sortDirection: 'desc',
          customBodyRender: (value: Date) =>
            moment.utc(value).local().format(this.props.appState.longDateFormat)
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        options: {
          viewColumns: false,
          filter: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={(e) => this.newMaintenanceWorkflowPopup(tableMeta.rowData[0])}
                >
                  <EditOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => this.deleteMaintenanceWorkflow(e, tableMeta)}
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </>
            );
          }
        }
      }
    ];
    return columns;
  };

  deleteMaintenanceWorkflow = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];
      await this.organizationService.RemoveMaintenanceWorkflow(id);
      await this.loadMaintenanceWorkflows();
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  newMaintenanceWorkflowPopup = async (maintenanceWorkflowId: number | null) => {
    let newMaintenanceWorkflow: MaintenanceWorkflow;
    if (maintenanceWorkflowId == null) {
      newMaintenanceWorkflow = { ...this.state.newMaintenanceWorkflow } as MaintenanceWorkflow;
    } else {
      newMaintenanceWorkflow = this.state.maintenanceWorkflows.find(
        (item) => item.id === maintenanceWorkflowId
      )!;
    }
    this.setState({
      isDialogOpen: true,
      newMaintenanceWorkflow: newMaintenanceWorkflow,
      newMaintenanceWorkflowId: maintenanceWorkflowId
    });
  };

  closeDialog = async () => {
    this.setState({
      isDialogOpen: false,
      newMaintenanceWorkflow: this.newMaintenanceWorkflow
    });
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.organizationService = (this.context as AppContext).organizationService;
    this.appReferentialService = (this.context as AppContext).referentialService;
    const options = {
      filter: true,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      sort: false,
      // responsive: "stacked",
      customToolbar: () => {
        return (
          <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
            <IconButton
              aria-label="add"
              color="secondary"
              className="m-2"
              onClick={(e) => this.newMaintenanceWorkflowPopup(null)}
            >
              <AddCircleTwoToneIcon />
            </IconButton>
          </Tooltip>
        );
      }
    };
    return (
      <Fragment>
        <Box mt={1} pt={1}>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? (
            <MUIDataTable
              title={''}
              data={this.state.maintenanceWorkflows}
              columns={this.getColumns()}
              options={options}
            />
          ) : null}
        </Box>
        {this.state.isDialogOpen ? (
          <Dialog
            onClose={this.closeDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isDialogOpen}
            fullWidth={true}
            maxWidth={'sm'}
          >
            <DialogTitle id="customized-dialog-title">
              <Grid container>
                <Grid item xs={11}>
                  <Typography variant="h4">
                    {!this.state.newMaintenanceWorkflowId
                      ? this.translatorService.Tranlate(
                          'MAINTENANCE_WORKFLOW_ADD_MODAL_TITLE',
                          'Adauga flux de mentenanta pe tara'
                        )
                      : this.translatorService.Tranlate(
                          'MAINTENANCE_WORKFLOW_UPDATE_MODAL_TITLE',
                          'Actualizeaza flux de mentenanta pe tara'
                        )}
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>{this.renderAddForm()}</DialogContent>
          </Dialog>
        ) : null}
      </Fragment>
    );
  }
}
export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(ConfigurableWorkflowComponent as any));
